import AV from 'leancloud-storage'

export const XTAlbum = AV.Object.extend('XTAlbum')

// 获取公开的推荐专辑
XTAlbum.getPublicRecommendXTAlbums = function (page = 1, perPage = 15) {
  return AV.Cloud.rpc('getPublicRecommendXTAlbums', {
    page,
    perPage,
    free: true
  })
}

// 获取推荐的标签及包括的专辑
XTAlbum.getXTAlbumTagsWithAlbums = function (page = 1, perPage = 15) {
  return AV.Cloud.rpc('getXTAlbumTagsWithAlbums', {
    page,
    perPage,
    free: true
  })
}

// 根据标签获取专辑
XTAlbum.getXTAlbumsByTag = function (tagId, page = 1, perPage = 15) {
  return AV.Cloud.rpc('getXTAlbumsByTag', {
    tagId,
    page,
    perPage,
    free: true
  })
}

// 根据 xmId 列表获取声音列表
XTAlbum.getXTTracksByXMIds = function (xmIds) {
  return AV.Cloud.rpc('getXTTracksByXMIds', {
    xmIds
  })
}

// 通过AlbumId 获取Album
XTAlbum.getById = function (albumId) {
  // return AV.Cloud.rpc('')
  return AV.Cloud.rpc('getXTAlbumById', {
    id: albumId
  })
}



// WEBPACK FOOTER //
// ./src/models/xct_album.js